import {Navigate} from "react-router-dom";
import Home from "pages/app/home";
import Report from "pages/app/Report";
import Scan from "pages/app/scan";
import Profile from "pages/app/Profile";

import EditePatient from "components/EditPatientProfile/EditePatient";
import FAQ from "components/FAQ/FAQ";

export const appRoutes = [
    {
        name: "home",
        route: '/home',
        component: <Home />,
    },
    {
        name: "report",
        route: '/report',
        component: <Report />,
    },
    {
        name: "scan",
        route: `/scan`,
        component: <Scan />,
    },
    {
        name: "edit",
        route: `/edit`,
        component: <EditePatient />,
    },
    {
        name: "faq",
        route: `/faq`,
        component: <FAQ />,
    },
    {
        name: "profile",
        route: `/profile`,
        component: <Profile />,
    },
    {
        name: "home",
        route: `/*`,
        component: <Navigate to='home' />,
    }
];

